import { Component } from 'js-component-framework';

/**
 * Component for search flyout
 */
export default class TableOfContents extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
    this.getSectionBounds = this.getSectionBounds.bind(this);
    this.setActiveBGColor = this.setActiveBGColor.bind(this);
  }

  getSectionBounds() {
    // get all the anchors in the HTML and save their boundary points.
    const boundaries = [];
    const items = document.querySelectorAll('.table-of-contents__item');
    items.forEach((item, i) => {
      item.childNodes.forEach((child) => {
        if ('A' === child.tagName) {
          const anchor = child.getAttribute('href');
          const dimensions = document.querySelector(anchor).getBoundingClientRect(); // eslint-disable-line max-len

          boundaries.push({
            section: anchor,
            top: dimensions.top,
            bottom: document.body.scrollHeight,
          });

          // since we can't keep track of how long a "section" is past the anchor element, we'll use the next anchor's dimensions as proxy.
          if (0 <= i - 1) {
            boundaries[i - 1].bottom = dimensions.top - 5;
          }

          // we'll use said boundary points globally.
          this.globalbounds = boundaries;
        }
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  setActiveBGColor(globalbounds) {
    // eslint-disable-next-line max-len
    const lowestTop = globalbounds.reduce((min, obj) => (obj.top < min ? obj.top : min), globalbounds[0].top);
    const firstItem = document
      .querySelector('.table-of-contents__list li:first-child');

    // find which section of the page the user is currently looking at
    globalbounds.forEach((zone) => {
      if (window.scrollY < lowestTop) {
        // Check to see if the first ToC item has the active class. Remove it if it does.
        if (firstItem && firstItem.classList.contains('active')) {
          firstItem.classList.remove('active');
        }
      }
      if (window.scrollY > zone.top && window.scrollY < zone.bottom) {
        // add active class to the TOC block item corresponding to our current section
        // eslint-disable-next-line max-len
        const zoneSelect = document.querySelector(`[href="${zone.section}"]`).parentNode;
        if (! zoneSelect.classList.contains('active')) {
          zoneSelect.classList.add('active');
        } else if (document.querySelectorAll('.active')) {
          document.querySelectorAll('.active').forEach((item) => {
            item.classList.remove('active');
          });
          zoneSelect.classList.add('active');
        }
      }
    });
  }

  init() {
    const {
      target,
      globalbounds,
    } = this.children;

    if (! target) {
      return;
    }

    this.getSectionBounds(globalbounds);

    window.addEventListener('resize', this.getSectionBounds(globalbounds));

    // eslint-disable-next-line max-len
    window.addEventListener('scroll', () => this.setActiveBGColor(this.globalbounds));
  }
}
